import { CRUD } from "@/shared/components";
import {
  UsersListQuery,
  UserShowQuery,
  DeleteUsersMutation,
  RestoreUsersMutation,
} from "@/admin/entities/users";
import { useUser } from "@/admin/entities/auth";
import { useUsersManagement, type UserRow } from "../model";
import * as UsersSchemas from "../model/schemas";
import { createEditSchema } from "../model/schemas";
import { UserShowComponent } from "@/admin/features/users";

/**
 * UI компонент для управления пользователями
 * Чистый презентационный компонент, использует логику из model слоя
 * GraphQL операции импортирует из user entity
 */
export function Users() {
  const { columns, mobileColumns, mapColumns, getTableData, texts } =
    useUsersManagement();
  // Вкладка «Админ» — только суперадмину (референс: editSchema(isSuperAdmin),
  // Users.js:564-574).
  const { user } = useUser();

  return (
    <CRUD<UserRow>
      listQuery={UsersListQuery}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={columns}
      filterSchema={UsersSchemas.filterSchema}
      createSchema={UsersSchemas.createSchema}
      editSchema={createEditSchema(
        UserShowComponent,
        Boolean(user?.isSuperAdmin)
      )}
      editQuery={UserShowQuery}
      deleteMutation={DeleteUsersMutation}
      restoreMutation={RestoreUsersMutation}
      texts={texts}
      persistFilters
      useMobileView
      mobileColumns={mobileColumns}
    />
  );
}
